// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller"

export default class ProfileListController extends AdvancedController {

  static targets = [
    // TODO: use or remove
    // "exampleTarget",
    "body", "toggle"
  ];

  static values = {
    // TODO: use or remove
    // exampleString: String,
    // exampleDefault: { type: Number, default: 42 },
  }

  connect() {
    super.connect(...arguments)
    // TODO: use or remove
  }


  toggle() {

    if (this.bodyTarget.classList.contains('-open')) {
      this.bodyTarget.classList.remove("-open");
      this.toggleTarget.classList.remove("-open");
    } else {
      this.bodyTarget.classList.add("-open");
      this.toggleTarget.classList.add("-open");

    }
  }
}
